import { headlessLinks } from '@app/constants/links';
import { replaceTokensInString } from '@app/utils';

export const getSuggestedDiagrams = (suggestedDiagram, esiteURL) => {
  const numberOfItems = 5;
  const partsDiagram = suggestedDiagram?.slice(0, numberOfItems).map(item => ({
    ...item,
    name: `${item.partNumber} ${item.name}`,
    value: replaceTokensInString(
      headlessLinks.HEADLESS_PARTS_DIAGRAM_REDIRECTION_LINK,
      esiteURL,
      item.systemId,
      item.componentId,
      item.systemControlNumber
    )
  }));

  return partsDiagram;
};
